export type BadgePost = { id: string; author_id: string; community_id?: string; visibility?: string | null };

export function countUnseenPosts(posts: BadgePost[], seen: Set<string>, userId: string, allowed: (post: BadgePost) => boolean) {
  return new Set(posts.filter((post) => post.author_id !== userId && !seen.has(post.id) && allowed(post)).map((post) => post.id)).size;
}
